import { cn } from "@babackapp/ui/lib/utils";
import { Column, Container, Img, Row, Link } from "@react-email/components";
import { useEmailThemeRadius } from "../../hooks/use-emails-theme-radius";
import { BannerBlockProps } from "./types";


export function BannerEmailRenderer(props: BannerBlockProps) {
  const imageRadius = useEmailThemeRadius(props.theme, "bannerImage");

  const item = props.block.properties?.items?.[0];

  const itemHref = item?.href;
  const imageUrl = item?.imageId
    ? `https://baback-banner-images.s3.eu-west-3.amazonaws.com/${item.imageId}`
    : (item?.imageUrl ?? "#");

  return (
    <Container className="w-full">
      <Row>
        <Column>
          {itemHref ? (
           <Link href={itemHref}>
             <Img
               src={imageUrl}
               alt="Banner"
               className={cn(imageRadius, "h-auto w-full object-cover block mr-2")}
             />
           </Link>
          ) : (
            <Img
              src={imageUrl}
              alt="Banner"
              className={cn(imageRadius, "h-auto w-full object-cover block mr-2")}
            />
          )}
        </Column>
      </Row>
    </Container>
  );
}
